import { UNBOUND_VALUE_TYPE } from 'features/common/constants/configurationKey';
import { useApolloClient } from '@apollo/client';

const invalidateApolloClientCache = (client, obj, fields = null) => {
  const cacheId = client.cache.identify(obj);

  if (fields === null) client.cache.evict({ id: cacheId });
  else fields.forEach(field => client.cache.evict({ id: cacheId, fieldName: field }));

  client.cache.gc();
};

const useResetCache = () => {
  const client = useApolloClient();

  const resetApolloCache = configurationKeys => {
    const objectTypedRootQueries = configurationKeys.rootQueryEntries.filter(z => z.type && z.type !== UNBOUND_VALUE_TYPE);
    Object.keys(client.cache.data.data).forEach(cacheKey => {
      const configKey = objectTypedRootQueries.find(z => cacheKey.match(z.type));
      if (configKey) {
        client.cache.data.delete(cacheKey);
        client.cache.evict({ id: 'ROOT_QUERY', fieldName: configKey.query });
      }
    });

    /* Evict values that have no type directly from ROOT_QUERY */
    const singleValueRootQueries = configurationKeys.rootQueryEntries.filter(z => z.type && z.type === UNBOUND_VALUE_TYPE);
    singleValueRootQueries.forEach(config => {
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: config.query });
    });

    /* Evict single pieces belonging to other queries. Used for smaller individual types aggregated to other types and with no associated query in ROOT_QUERY*/
    const cacheEntryKeys = configurationKeys.cacheEntries;
    cacheEntryKeys.forEach(cacheEntryKey => {
      const cacheKeys = Object.keys(client.cache.data.data).filter(x => x.startsWith(`${cacheEntryKey}:{`));
      cacheKeys.forEach(key => client.cache.evict({ id: key }));
      client.cache.gc();
    });
  };

  return { resetApolloCache };
};

export { invalidateApolloClientCache, useResetCache };
